export const config = {
  apiKey: process.env.NEXT_PUBLIC_API_KEY!,
  baseURL: process.env.NEXT_PUBLIC_BASE_URL!,
  apiVersion: "v1",
} as const;

export type Config = typeof config;
